import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import MaybeButtonLink from "components/Shared/MaybeButtonLink";
import { NameWithFlagIcons } from "components/Shared/RetailerDirectory/utils";

const fragment = gql(/* GraphQL */ `
  fragment MaybeRetailerLinkFragment on Retailer {
    id
    ...RetailerNameWithFlagIconsFragment
  }
`);

type Props = {
  onClick?: (retailerId: UUID) => void;
  retailer: FragmentType<typeof fragment> | null | undefined;
};

export default function MaybeRetailerLink({
  onClick,
  retailer: retailerFragment,
}: Props) {
  const retailer = getFragmentData(fragment, retailerFragment);
  return (
    <MaybeButtonLink
      onClick={
        onClick && retailer
          ? () => {
              onClick(retailer.id);
            }
          : undefined
      }
    >
      <NameWithFlagIcons retailer={retailer} />
    </MaybeButtonLink>
  );
}
